import { nanoid } from 'nanoid'

;(function () {
  'use strict'

  angular.module('deskfy.core').controller('CoreDataFrameTableController', CoreDataFrameTableController)

  const getDeleteAdminDesignerDialogController = () =>
    import('../../../admin/dialogs/delete-admin-designer/delete-admin-designer-dialog.controller')
  const getDeleteUserDialogNewController = () =>
    import('../../../admin/dialogs/delete-user-new/delete-user-dialog-new.controller')
  const getManageUserStatusDialogController = () =>
    import('../../../core/dialogs/manage-user-status/manage-user-status-dialog.controller')
  const getManageGuestStatusDialogController = () =>
    import('../../../core/dialogs/manage-guest-status/manage-guest-status-dialog.controller')
  const getDeleteUserNoMovimentationDialogController = () =>
    import('../../../admin/dialogs/delete-user-no-movimentation/delete-user-no-movimentation-dialog.controller')
  const getWarningMessageDialogController = () => import('../../dialogs/warning-message/warning-message-dialog.controller')
  const getAddToGroupsDialogController = () => import('../../dialogs/add-to-groups/add-to-groups-dialog.controller')
  const getRestoreUserNewDialogController = () => import('../../../admin/dialogs/restore-user-new/restore-user-dialog-new.controller')

  /* @ngInject */
  function CoreDataFrameTableController ($scope, $rootScope, $timeout, $translate, $window, AdminService, UdsModalService, ToastService) {
    const getUpgradeCompanyPlanDialogController = () => import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')

    $scope.params = {
      $sort: null,
      $order: null
    }

    $scope.selectedItems = []
    $scope.allSelected = false
    $scope.activeSelected = false
    $scope.inactiveSelected = false
    $scope.pendingSelected = false

    $scope.warningMessageModal = {
      show: false,
      loading: false,
      message: '',
      cancelButtonlLabel: '',
      confirmButtonLabel: '',
      onConfirm: function () {},
      onClose: function () {}
    }

    $scope.companyFeatures = {
      placeholderTexts: {
        access: false,
        data: {}
      }
    }

    $scope.textLimit = 25
    $scope.userLimit = 25

    $scope.tableHtmlId = nanoid()

    const api = {
      getRestoreUserNewDialogController,
      getUpgradeCompanyPlanDialogController,
      _checkSortOrder,
      _afterSelectItems,
      _unselectItems,
      _successUpdateUserStatus,
      _errorUpdateUserStatus,
      _checkIfAllSelected,
      _updateGrid,
      _showSuccessToast,
      _showErrorToast,
      _openUpgradeCompanyPlanDialog,
      _getCompanyFeatures,
      _successUpdateGuestStatus
    }

    this.getApi = () => api

    $scope.successUpdateUserStatus = api._successUpdateUserStatus
    $scope.errorUpdateUserStatus = api._errorUpdateUserStatus

    activate()

    function activate () {
      api._getCompanyFeatures()
      api._updateGrid()
    }

    const deregisterUnselectAll = $scope.$on('multiselect-groups.unselect-all', () => {
      api._unselectItems()
    })

    const deregisterCoreFiltersUpdate = $scope.$on('core-filters.update', (e, filterParams) => {
      $scope.data.updateFilters('filters', filterParams)
    })

    const deregisterUpdateGrid = $scope.$on('core-table.updateGrid', () => {
      api._updateGrid()
    })

    $scope.$on('$destroy', () => {
      deregisterUnselectAll()
      deregisterCoreFiltersUpdate()
      deregisterUpdateGrid()
    })

    $scope.handleBusinessDataFieldsClick = (rowId) => {
      if (!$scope.companyFeatures.placeholderTexts.access) {
        _openUpgradeCompanyPlanDialog()
      } else {
        $scope.data.editButton.openBusinessDataFieldsModal(rowId)
      }
    }

    function _openUpgradeCompanyPlanDialog () {
      api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
        const upgradeCompanyPlanDialog = UdsModalService.createModal({
          controller: UpgradeCompanyPlanDialogController,
          modalName: 'upgradeCompanyPlanDialog',
          data: $scope.companyFeatures.placeholderTexts.data
        })
        upgradeCompanyPlanDialog.open()
      })
    }

    $scope.emptyMode = function () {
      return !$scope.data.rows || !$scope.data.rows.length
    }

    $scope.changeLoading = function (value) {
      $scope.loading = value
    }

    $scope.sortColumnClick = column => {
      if (!column.orderable) {
        return
      }

      if ($scope.params.$sort === column.value) {
        api._checkSortOrder($scope.params.$order)
      } else {
        $scope.params.$sort = column.value
        $scope.params.$order = 'ASC'
      }

      $scope.data.updateSort({ $sort: $scope.params.$sort, $order: $scope.params.$order })
    }

    $scope.handleSubmitSearch = function (event) {
      const searchTerm = event.detail.value
      $scope.data.updateFilters('search', searchTerm)
    }

    $scope.handleChangeSearch = function (event) {
      const searchTerm = event.detail.value

      if (searchTerm === '') {
        // clear search
        $scope.data.updateFilters('search', searchTerm)
      }
    }

    $scope.openAddToGroupsModal = function () {
      $scope.openAddToGroupsDialog()
    }

    $scope.openWarningMessageDialog = function (users) {
      getWarningMessageDialogController().then(({ WarningMessageDialogController }) => {
        const warningMessageDialog = UdsModalService.createModal({
          controller: WarningMessageDialogController,
          modalName: 'warningMessageDialog',
          data: {
            show: true,
            loading: false,
            message: $translate.instant('inactivateUserAssignees'),
            cancelButtonLabel: $translate.instant('no'),
            confirmButtonLabel: $translate.instant('yes')
          },
          onClose: (returnData) => {
            if (returnData.onConfirm) {
              const userIds = users.map(user => user.id)
              AdminService.inactivateSelectedUsers(userIds)
                .then(() => {
                  $scope.warningMessageModal.onClose()
                  api._successUpdateUserStatus()
                })
                .catch(api._errorUpdateUserStatus)
            }
          }
        })

        warningMessageDialog.open()
      })
    }

    $scope.openAddToGroupsDialog = function () {
      getAddToGroupsDialogController().then(({ AddToGroupsDialogController }) => {
        const addToGroupsDialog = UdsModalService.createModal({
          controller: AddToGroupsDialogController,
          modalName: 'addToGroupsDialog',
          data: {
            users: $scope.selectedItems
          }
        })

        addToGroupsDialog.open()
      })
    }

    $scope.handleSelectItem = function (item) {
      const index = $scope.selectedItems.findIndex(selected => selected.id === item.id)

      if (index !== -1) {
        item.selected = false
        $scope.selectedItems.splice(index, 1)
      } else {
        item.selected = true
        $scope.selectedItems.push(item)
      }

      api._checkIfAllSelected()
      api._afterSelectItems()
    }

    $scope.handleSelectAll = function (event) {
      const isChecked = event.detail.value

      if ($scope.selectedItems.length !== $scope.data.rows.length && isChecked) {
        $scope.selectedItems = []

        $scope.data.rows.forEach(row => {
          row.selected = true
          $('uds-checkbox#user-checkbox-' + row.id).attr('checked', true)
        })

        $scope.selectedItems.push(...$scope.data.rows)
      } else if ($scope.selectedItems.length === $scope.data.rows.length && !isChecked) {
        $scope.selectedItems = []

        $scope.data.rows.forEach(row => {
          row.selected = false
          $('uds-checkbox#user-checkbox-' + row.id).removeAttr('checked')
        })
      }

      api._afterSelectItems()
    }

    $scope.multiselectShowingText = function () {
      const firstNumber = $scope.data.rows.length === 0 ? 0 : $scope.data.paging.index * $scope.data.paging.top + 1
      const lastNumber =
        firstNumber + $scope.data.paging.top - 1 > $scope.data.paging.count
          ? $scope.data.paging.count
          : firstNumber + $scope.data.paging.top - 1

      if ($scope.data.alternativeHeaderCounterText) {
        let text = $translate.instant('showing2')
        text += ` ${firstNumber}-${lastNumber}`
        text += ' ' + $translate.instant('of')
        text += ' ' + $scope.data.paging.count
        text += ' ' + $scope.data.alternativeHeaderCounterText
        return text
      }

      let text = $translate.instant('showing2')
      text += ` ${firstNumber}-${lastNumber}`
      text += ' ' + $translate.instant('of')
      text += ' ' + $scope.data.paging.count
      text += ' ' + $translate.instant('users').toLowerCase()

      return text
    }

    $scope.resendInvites = function (users) {
      const userIds = []
      $scope.loading = true

      users.forEach(user => {
        if (user.userStatus === 'PENDING_INVITE') {
          userIds.push(user.id)
        }
      })

      AdminService.resendInvitatesByUsers(userIds)
        .then(() => {
          api._showSuccessToast()
          api._unselectItems()
        })
        .catch(api._showErrorToast)
        .finally(() => {
          $scope.loading = false
        })
    }

    $scope.openDeleteUserDialog = function (user) {
      const userName = user.values[0].value.name

      getDeleteUserDialogNewController().then(({ DeleteUserNewDialogController }) => {
        const deleteUserDialogNew = UdsModalService.createModal({
          controller: DeleteUserNewDialogController,
          modalName: 'deleteUserDialogNew',
          data: {
            user: { ...user, userName }
          }
        })

        deleteUserDialogNew.open()
      })
    }

    $scope.openDeleteAdminDesignerDialog = function (user) {
      const userName = user.values[0].value.name

      getDeleteAdminDesignerDialogController().then(({ DeleteAdminDesignerDialogController }) => {
        const deleteAdminDesignerDialog = UdsModalService.createModal({
          controller: DeleteAdminDesignerDialogController,
          modalName: 'deleteAdminDesignerDialog',
          data: {
            user: { ...user, userName }
          }
        })

        deleteAdminDesignerDialog.open()
      })
    }

    $scope.openDeleteUserNoMovimentationDialog = function (user) {
      const userName = user.values[0].value.name
      getDeleteUserNoMovimentationDialogController().then(({ DeleteUserNoMovimentationDialogController }) => {
        const DeleteUserNoMovimentationDialog = UdsModalService.createModal({
          controller: DeleteUserNoMovimentationDialogController,
          modalName: 'deleteUserNoMovimentationDialog',
          data: {
            user: { ...user, userName }
          }
        })

        DeleteUserNoMovimentationDialog.open()
      })
    }

    $scope.deleteUserClick = function (user) {
      if (user.values[0].value.role === 'USER' && user.userStatus !== 'PENDING_INVITE') {
        $scope.openDeleteUserDialog(user)
      } else if (user.userStatus === 'PENDING_INVITE') {
        $scope.openDeleteUserNoMovimentationDialog(user)
      } else {
        $scope.openDeleteAdminDesignerDialog(user)
      }
    }

    $scope.openRestoreUserDialog = function (user) {
      const userName = user.values[0].value.name

      getRestoreUserNewDialogController().then(({ RestoreUserNewDialogController }) => {
        const restoreUserNewDialog = UdsModalService.createModal({
          controller: RestoreUserNewDialogController,
          modalName: 'restoreUserDialogNew',
          data: {
            user: { ...user, userName }
          }
        })

        restoreUserNewDialog.open()
      })
    }

    $scope.activateUser = function (user) {
      getManageUserStatusDialogController().then(({ ManageUserStatusDialogController }) => {
        const manageUserStatusDialog = UdsModalService.createModal({
          controller: ManageUserStatusDialogController,
          modalName: 'manageUserStatusDialog',
          data: {
            user: user,
            type: 'activate'
          },
          onClose: (isSuccess, error) => {
            if (isSuccess) {
              api._successUpdateUserStatus()
            } else if (error) {
              api._errorUpdateUserStatus(error)
            }
          }
        })

        manageUserStatusDialog.open()
      })
    }

    $scope.activateUsers = function (users) {
      $scope.loading = true
      AdminService.activateSelectedUsers(users)
        .then(api._successUpdateUserStatus)
        .catch(api._errorUpdateUserStatus)
    }

    $scope.inactivateUser = function (user) {
      getManageUserStatusDialogController().then(({ ManageUserStatusDialogController }) => {
        const manageUserStatusDialog = UdsModalService.createModal({
          controller: ManageUserStatusDialogController,
          modalName: 'manageUserStatusDialog',
          data: {
            user: user,
            type: 'inactivate'
          },
          onClose: (isSuccess, error) => {
            if (isSuccess) {
              api._successUpdateUserStatus()
            } else if (error) {
              api._errorUpdateUserStatus()
            }
          }
        })

        manageUserStatusDialog.open()
      })
    }

    $scope.inactivateUsers = function (users) {
      $scope.openWarningMessageDialog(users)
    }

    $scope.activateGuest = function (guest) {
      getManageGuestStatusDialogController().then(({ ManageGuestStatusDialogController }) => {
        const manageGuestStatusDialog = UdsModalService.createModal({
          controller: ManageGuestStatusDialogController,
          modalName: 'manageGuestStatusDialog',
          data: {
            guest: guest,
            type: 'activate'
          },
          onClose: (isSuccess, error) => {
            if (isSuccess) {
              api._successUpdateGuestStatus(guest.name, 'activate')
            } else if (error) {
              api._errorUpdateUserStatus()
            }
          }
        })

        manageGuestStatusDialog.open()
      })
    }

    $scope.inactivateGuest = function (guest) {
      getManageGuestStatusDialogController().then(({ ManageGuestStatusDialogController }) => {
        const manageGuestStatusDialog = UdsModalService.createModal({
          controller: ManageGuestStatusDialogController,
          modalName: 'manageGuestStatusDialog',
          data: {
            guest: guest,
            type: 'inactivate'
          },
          onClose: (isSuccess, error) => {
            if (isSuccess) {
              api._successUpdateGuestStatus(guest.name, 'inactivate')
            } else if (error) {
              api._errorUpdateUserStatus()
            }
          }
        })

        manageGuestStatusDialog.open()
      })
    }

    function _successUpdateGuestStatus (name, type) {
      $scope.loading = false
      if (type === 'inactivate') {
        ToastService.showSuccessToast($translate.instant('manageGuests.toasts.inactivateGuest', { guestName: name }))
      } else {
        ToastService.showSuccessToast($translate.instant('manageGuests.toasts.activateGuest', { guestName: name }))
      }
      $rootScope.$broadcast('guests.reloadAllGuests')
    }

    function _checkSortOrder (orderScope) {
      const orders = {
        ASC: () => {
          $scope.params.$order = 'DESC'
        },
        DESC: () => {
          $scope.params.$order = 'DESC'
          $scope.params.$sort = 'createdAt'
        }
      }

      orders[orderScope]()
    }

    function _getCompanyFeatures () {
      $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
        $scope.companyFeatures.placeholderTexts = {
          access: !!features['ARTS.EDITOR_AUTOMATIC_FIELDS'],
          data: {
            featureName: $translate.instant('billingFeatures.artsEditorAutomaticFields'),
            featureSlug: 'ARTS.EDITOR_AUTOMATIC_FIELDS'
          }
        }
      })
    }

    function _afterSelectItems () {
      if (!$scope.selectedItems.length) return

      $scope.activeSelected = $scope.selectedItems.every(item => item.userStatus === 'ACTIVE')
      $scope.inactiveSelected = $scope.selectedItems.every(item => item.userStatus === 'INACTIVE')
      $scope.pendingSelected = $scope.selectedItems.every(item => item.userStatus === 'PENDING_INVITE')
    }

    function _unselectItems () {
      $scope.data.rows.forEach(row => {
        row.selected = false
        $('uds-checkbox#user-checkbox-' + row.id).removeAttr('checked')
      })
      $scope.selectedItems = []

      $scope.allSelected = false
      $('uds-checkbox.select-all-checkbox').removeAttr('checked')
    }

    function _checkIfAllSelected () {
      $scope.allSelected = $scope.selectedItems.length === $scope.data.rows.length
      if ($scope.allSelected) {
        $('uds-checkbox.select-all-checkbox').attr('checked', true)
      } else {
        $('uds-checkbox.select-all-checkbox').removeAttr('checked')
      }
    }

    function _showSuccessToast (label) {
      const toastLabel = label || $translate.instant('successTitle')
      ToastService.showSuccessToast(toastLabel)
    }

    function _showErrorToast (label) {
      const toastLabel = label || $translate.instant('somethingWentWrongTryAgainMsg')
      ToastService.showErrorToast(toastLabel)
    }

    function _successUpdateUserStatus () {
      $scope.loading = false
      ToastService.showSuccessToast($translate.instant('successTitle'))
      api._unselectItems()
      $scope.$emit('users.reloadAllUsers')
      $scope.$emit('users.reloadActiveUsers')
    }

    function _errorUpdateUserStatus (e) {
      $scope.loading = false

      if (e && e.data && e.data.code) {
        if (e.data.code === 'LIMIT_ACTIVE_USERS_REACHED') {
          api._showErrorToast($translate.instant('usersMaximumReached'))
        } else {
          api._showErrorToast($translate.instant('error'))
        }
      } else {
        api._showErrorToast($translate.instant('error'))
      }
    }

    $scope.onLastRowLoad = () => {
      api._updateGrid()
    }

    function _updateGrid () {
      $(`#${$scope.tableHtmlId}.data-frame-table-body thead tr`).css('grid-template-columns', $scope.data.columnsGrid)
      $(`#${$scope.tableHtmlId}.data-frame-table-body tbody tr`).css('grid-template-columns', $scope.data.columnsGrid)

      $timeout(() => {
        const textWidth = $('.core-data-frame-table-container .table-content-row table-column-row-text').css('width')
        const userWidth = $(
          '.core-data-frame-table-container .table-content-row table-column-row-user .user-tooltip'
        ).css('width')

        if (!textWidth || !userWidth || textWidth === '0px' || userWidth === '0px') {
          const widthScreen = $window.innerWidth

          if (widthScreen > 1700) {
            $scope.textLimit = 30
            $scope.userLimit = 22
          } else if (widthScreen > 1400) {
            $scope.textLimit = 24
            $scope.userLimit = 14
          } else if (widthScreen > 1285) {
            $scope.textLimit = 18
            $scope.userLimit = 12
          } else {
            $scope.textLimit = 14
            $scope.userLimit = 8
          }
        } else {
          $scope.textLimit = parseInt(parseInt(textWidth) / 9)
          $scope.userLimit = parseInt(parseInt(userWidth) / 9)
        }
      }, 1000)
    }
  }
})()
